import React from 'react'
import ReactDOM from 'react-dom/client'
import { Toaster } from 'react-hot-toast'
import App from './App'
import ErrorBoundary from './ErrorBoundary'
import { AppProvider } from './context/AppContext'
import { initSentry } from './lib/sentry'
import { initTheme } from './lib/theme'
import './styles/index.css'

// No-op unless VITE_SENTRY_DSN is configured.
initSentry()
// Menyelaraskan data-theme dengan pilihan tersimpan, dan mengikuti perubahan OS.
initTheme()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <AppProvider>
        <App />
        {/* Warna toast mengikuti token tema; bawaannya putih tetap di mode gelap. */}
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: { background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)' },
          }}
        />
      </AppProvider>
    </ErrorBoundary>
  </React.StrictMode>
)
